import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

import { computed } from 'vue'
import { pillClasses } from '@/components/catering/pillClasses'

export default {
  __name: 'Pill',
  props: {
  tone: { type: String, default: 'neutral' },
  size: { type: String, default: 'md' },
  dot: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props
const c = computed(() => pillClasses(props.tone, props.size))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(c.value.wrap)
  }, [
    (__props.dot)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(c.value.dot)
        }, null, 2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

}